import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'kt-tif-view-dialog',
  templateUrl: 'tif-view-dialog.component.html',
  styleUrls: ['tif-view-dialog.component.scss'],
})
export class TifViewDialogComponent implements OnInit {
  showDownloadBtn = false;
  loadingTif = new BehaviorSubject(true);
  pages = [];
  pageIndex = 0;
  zoomScale = 1;

  ngOnInit() {
    this.showDownloadBtn = false;

    const xhr = new XMLHttpRequest();
    xhr.responseType = 'arraybuffer';
    xhr.open('GET', this.data.url);
    this.loadingTif.next(true);
    xhr.onload = () => {
      const TiffConstructor = (window as any).Tiff;
      const tiff = new TiffConstructor({ buffer: xhr.response });

      for (let i = 0, len = tiff.countDirectory(); i < len; i++) {
        tiff.setDirectory(i);
        const canvas = tiff.toCanvas();
        const url = canvas.toDataURL('image/png');
        this.pages.push(url);
      }

      this.loadingTif.next(false);
      this.cdr.detectChanges();
    };
    xhr.onerror = () => {
      this.showDownloadBtn = true;
    };
    xhr.send();
  }

  changePage(event: Event, nav: 'FIRST' | 'PREV' | 'NEXT' | 'LAST'): void {
    event.stopPropagation();

    switch (nav) {
      case 'FIRST':
        this.pageIndex = 0;
        break;

      case 'PREV':
        this.pageIndex = this.pageIndex > 0 ? this.pageIndex - 1 : this.pageIndex;
        break;

      case 'NEXT':
        this.pageIndex =
          this.pageIndex < this.pages.length - 1 ? this.pageIndex + 1 : this.pageIndex;
        break;

      case 'LAST':
        this.pageIndex = this.pages.length - 1;
        break;
    }
  }

  zoom(event: Event, type: 'IN' | 'OUT' | 'FIT'): void {
    event.stopPropagation();

    switch (type) {
      case 'IN':
        this.zoomScale = this.zoomScale * 1.1;
        break;

      case 'OUT':
        this.zoomScale = this.zoomScale * 0.9;
        break;

      case 'FIT':
        this.zoomScale = 1;
        break;
    }
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<TifViewDialogComponent>,
  ) {}

  close(event: Event): void {
    event.stopPropagation();

    this.dialogRef.close();
  }
}
